import React from "react";
import { Item } from "../../components/content/customAccordion/customAccordion";

export default function FAQ() {
  return (
    <div class="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full md:px-24 lg:px-8 lg:py-20">
      <div class="max-w-xl sm:mx-auto lg:max-w-2xl">
        <div class="flex flex-col mb-16 sm:text-center">
          <div class="max-w-xl md:mx-auto sm:text-center ">
            <h2 class="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto">
              Frequently asked questions
            </h2>
            <p class="text-base text-gray-700 md:text-lg">
              Do you need some help with something or do you have questions on
              some features ?
            </p>
          </div>
        </div>
        <div class="space-y-4">
          <Item title="What types of businesses can use MobiPOS?">
            MobiPOS is suitable for various types of businesses, including
            retail, food and beverage, hospitality, and more.
          </Item>
          <Item title="Is MobiPOS easy to use?">
            Yes, MobiPOS is designed to be user-friendly and intuitive, with a
            simple and modern interface.
          </Item>
          <Item title="Can I access MobiPOS from multiple devices?">
            Yes, MobiPOS allows you to access your account from multiple
            devices, including smartphones, tablets, and desktops.
          </Item>
          <Item title=" What are the hardware requirements for using MobiPOS?">
            MobiPOS can be used on a variety of devices, including smartphones,
            tablets, and desktops, as long as they meet the minimum system
            requirements.
          </Item>
          <Item title="Can I use MobiPOS offline?">
            Yes, MobiPOS offers offline mode, allowing you to continue
            processing transactions even without an internet connection
          </Item>
          <Item title="Can I generate reports and analytics with MobiPOS?">
            Yes, MobiPOS provides detailed reporting and analytics capabilities,
            allowing you to track sales, inventory, and customer behavior.
          </Item>
          <Item title="Can I use MobiPOS for multi-location management?">
            Yes, MobiPOS supports multi-location management, allowing you to
            manage multiple stores, restaurants, or locations from a single
            dashboard.
          </Item>
          <Item title="Does MobiPOS support barcode scanning?">
            Yes, MobiPOS is compatible with barcode scanners, making product
            entry and billing faster.
          </Item>
          <Item title="What types of POS devices are available with MobiPOS?">
            MobiPOS offers a range of Android-based POS devices, including
            handheld billing machines, touchscreen POS terminals, and integrated
            printers.
          </Item>
          <Item title="Does MobiPOS work on mobile and tablets?">
            Yes, MobiPOS is compatible with Android mobile phones and tablets.
          </Item>
          <Item title="Does MobiPOS support external accessories like weighing scales and receipt printers?">
            Yes, it supports integration with devices like weighing scales,
            external printers, and cash drawers.
          </Item>
          <Item title=" Is MobiPOS a one-time purchase or a subscription-based service?">
            MobiPOS offers both one-time purchase options and subscription-based
            plans, depending on your business needs.
          </Item>
          <Item title="How do I get support if I face any issues with MobiPOS?">
            Xenia Technologies provides customer support via phone, email, and
            live chat.
          </Item>
          <Item title="What operating system does MobiPOS run on?">
            MobiPOS runs on the Android OS of version 8 and above, making it
            compatible with various Android-based POS hardware.
          </Item>
          <Item title="What types of payment methods does MobiPOS accept?">
            MobiPOS supports multiple payment methods, including:
            <ul>
              <li>Cash</li>
              <li>Credit/Debit Cards (via integrated payment gateways)</li>
              <li>UPI & QR Code Payments</li>
              <li>Wallet Payments (Paytm, Google Pay, PhonePe, etc.)</li>
              <li>
                EMI & Credit Sales (for businesses offering credit accounts)
              </li>
            </ul>
          </Item>
          <Item title="Can I access reports remotely?">
            Yes, with MobiPOS cloud integration, you can access sales and stock
            reports from any device with an internet connection.
          </Item>
          <Item title="Is there a free trial available?">
            Yes, you can request a free demo of MobiPOS.
          </Item>
          <Item title="What types of POS hardware are available?">
            MobiPOS offers:
            <ul>
              <li>Touchscreen POS Terminals</li>
              <li>Handheld Android POS Machines</li>
              <li>Receipt Printers (Bluetooth, Wi-Fi, USB)</li>
              <li>Barcode Scanners & Weighing Scales</li>
            </ul>
          </Item>
        </div>
      </div>
    </div>
  );
}
